import { PortalHost } from "@gorhom/portal";
import { Modal } from "react-native";
import { allOrientations } from "../../../../../utilities/drag-drop";
import { PortalHostNames } from "../../../../../utilities/portals";

export const DragModal = () => {
  // NOTE: pointerEvents="none" must be specified here as Firefox does not propagate pointer events through the portal
  const pointerEvents = "none";

  return (
    <Modal
      {...{ pointerEvents }}
      transparent={true}
      supportedOrientations={allOrientations}
    >
      <PortalHost name={PortalHostNames.DRAG_DROP} />
    </Modal>
  );
};
